(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jp-cart"]) return;
  try {
    
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-cart-quantity]');
  if (!button) return;
  const form = button.closest('.jp-cart-form');
  const input = button.parentElement.querySelector('input[name="updates[]"]');
  if (!form || !input) return;
  const current = Number.parseInt(input.value, 10);
  const quantity = Number.isFinite(current) ? current : 0;
  input.value = String(button.dataset.cartQuantity === 'increase' ? quantity + 1 : Math.max(0, quantity - 1));
  const updateButton = form.querySelector('button[name="update"]');
  if (updateButton) form.requestSubmit(updateButton);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
